"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines-per-function */
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("@web3modal/wagmi/react");
const config_1 = require("@web3modal/wagmi/react/config");
const react_2 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const wagmi_1 = require("wagmi");
const chains_1 = require("wagmi/chains");
const constants_1 = __importStar(require("@/constants"));
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const carousel_nfts_1 = __importDefault(require("./carousel-nfts"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const web3_settings_1 = require("./web3-settings");
const WalletConnectionScreen = ({ location, wallets, nfts, addAddress, removeAddress, }) => {
    var _a;
    if (location) {
        //  Do Nothig. We are just using Location to remove warning.
    }
    const handleConnect = (wallet) => {
        addAddress(wallet);
    };
    const handleDisconnect = (id) => removeAddress(id);
    // const handleChange = ()=> {
    //   //  do something
    // }
    const queryClient = new react_query_1.QueryClient();
    const projectId = '3c70c1bc94904218b4500fd0a5a4b339';
    const metadata = {
        name: 'Web3Modal',
        description: 'Habitnest Web3Modal',
        url: 'https://web3modal.com',
        icons: ['https://avatars.githubusercontent.com/u/37784886']
    };
    const chains = [chains_1.mainnet, chains_1.arbitrum, chains_1.polygon];
    const config = (0, config_1.defaultWagmiConfig)({
        chains,
        projectId,
        metadata,
    });
    // Create modal
    (0, react_1.createWeb3Modal)({
        wagmiConfig: config,
        projectId,
        enableAnalytics: true, // Optional - defaults to your Cloud configuration
        enableOnramp: true, // Optional - false as default
        allowUnsupportedChain: false,
        allWallets: 'HIDE',
        featuredWalletIds: [
            '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // WalletConnect
            'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
            '87eecbca66faef32f044fc7c66090fc668efb02e2d17dda7bf095d51dff76659', // Crossmint
            '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust
        ],
        excludeWalletIds: [
            'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa', // Coinbase
        ]
    });
    return (react_2.default.createElement("div", { className: styles_scss_1.default.container },
        react_2.default.createElement("h1", { className: styles_scss_1.default.title }, constants_1.default.walletConnection.web3Integration),
        react_2.default.createElement("h5", { className: styles_scss_1.default.text }, constants_1.default.walletConnection.connectingtoWalletOptional),
        react_2.default.createElement("h5", { className: styles_scss_1.default.text }, constants_1.default.walletConnection.enableToEligibleForBonuses),
        react_2.default.createElement(wagmi_1.WagmiProvider, { config: config },
            react_2.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
                react_2.default.createElement(ConnectedWallet, { handleConnect: handleConnect, handleDisconnect: handleDisconnect, wallets: wallets }),
                react_2.default.createElement(carousel_nfts_1.default, { isWalletConnected: ((_a = wallets === null || wallets === void 0 ? void 0 : wallets.length) !== null && _a !== void 0 ? _a : 0) > 0, nfts: nfts })))));
};
const ConnectedWallet = ({ handleConnect, handleDisconnect, wallets }) => {
    var _a, _b, _c, _d, _e;
    const { address, isConnected, isDisconnected } = (0, wagmi_1.useAccount)();
    const { walletInfo } = (0, react_1.useWalletInfo)();
    const { open } = (0, react_1.useWeb3Modal)();
    const walletIcon = (name) => {
        if (name === 'MetaMask' || name === 'MetaMask Wallet') {
            return web3_settings_1.WalletsMeta.metamask.icon;
        }
        if (name === 'Coinbase' || name === 'Coinbase Wallet') {
            return web3_settings_1.WalletsMeta.coinbase.icon;
        }
        if (name === 'Crossmint | The easiest way to purchase and collect NFTs' || name === 'Crossmint') {
            return web3_settings_1.WalletsMeta.crossmint.icon;
        }
        if (name === 'Trust Wallet') {
            return web3_settings_1.WalletsMeta.trust.icon;
        }
        return web3_settings_1.WalletsMeta.walletconnect.icon;
    };
    (0, react_2.useEffect)(() => {
        if (address && isConnected && walletInfo && !(wallets === null || wallets === void 0 ? void 0 : wallets.length)) {
            const wallet = {
                address,
                icon: walletIcon(walletInfo === null || walletInfo === void 0 ? void 0 : walletInfo.name),
                name: walletInfo === null || walletInfo === void 0 ? void 0 : walletInfo.name,
                type: 'evm'
            };
            handleConnect(wallet);
        }
    }, [walletInfo, address]);
    (0, react_2.useEffect)(() => {
        var _a;
        if (!isConnected && isDisconnected && (wallets === null || wallets === void 0 ? void 0 : wallets.length) > 0) {
            handleDisconnect((_a = wallets[0]) === null || _a === void 0 ? void 0 : _a.id);
        }
    }, [isConnected]);
    return (react_2.default.createElement(react_2.default.Fragment, null, wallets.length === 0 ? (react_2.default.createElement("w3m-button", { balance: "hide", label: "Connect to Web3" })) : (react_2.default.createElement("div", { className: styles_scss_1.default.connectedWalletBtnContainer },
        ((_a = wallets[0]) === null || _a === void 0 ? void 0 : _a.icon) ? react_2.default.createElement("img", { src: (_b = wallets[0]) === null || _b === void 0 ? void 0 : _b.icon, alt: `Icon for ${(_c = wallets[0]) === null || _c === void 0 ? void 0 : _c.name}`, className: styles_scss_1.default.btnImage }) : null,
        react_2.default.createElement("div", { className: styles_scss_1.default.btnTextContainer },
            react_2.default.createElement("p", { className: styles_scss_1.default.btnHeading }, (_d = wallets[0]) === null || _d === void 0 ? void 0 : _d.name),
            react_2.default.createElement("p", { className: styles_scss_1.default.btnText }, (_e = wallets[0]) === null || _e === void 0 ? void 0 : _e.address),
            react_2.default.createElement("button", { style: { background: 'transparent' }, type: "button", onClick: () => open(), className: styles_scss_1.default.btnSubText }, constants_1.default.walletConnection.clickToDisconnect)),
        react_2.default.createElement("div", { className: styles_scss_1.default.btnChevronContainer },
            react_2.default.createElement("img", { src: constants_1.Images.chevronRight, alt: "Chevron to Right", style: { width: "9px", height: "14px" } }))))));
};
const mapStateToProps = (state) => {
    var _a, _b;
    return ({
        wallets: ((_a = selectors_1.default.user.getUser(state).wallets) !== null && _a !== void 0 ? _a : []).slice(0, 1),
        nfts: (_b = selectors_1.default.user.getUser(state).nfts) !== null && _b !== void 0 ? _b : []
    });
};
const mapDispatchToProps = (dispatch) => ({
    addAddress: (address) => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch((0, api_payloads_1.addWalletAddress)(address))),
    removeAddress: (id) => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch((0, api_payloads_1.removeWalletAddress)(id)))
});
WalletConnectionScreen.defaultProps = {
    location: null
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(WalletConnectionScreen);
